export default "__VITE_ASSET__q4EdzXXe__"